import { render, staticRenderFns } from "./WelcomeBannerPromotionComponent.vue?vue&type=template&id=7be2af6c&scoped=true"
import script from "./WelcomeBannerPromotionComponent.vue?vue&type=script&lang=js"
export * from "./WelcomeBannerPromotionComponent.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBannerPromotionComponent.vue?vue&type=style&index=0&id=7be2af6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2af6c",
  null
  
)

export default component.exports